export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  matchCount: number;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "足球",
    slug: "football",
    description: "全球顶级足球赛事直播、赛程资讯与深度分析",
    icon: "ri-football-line",
    matchCount: 48,
    articleCount: 156,
  },
  {
    id: "cat-2",
    name: "篮球",
    slug: "basketball",
    description: "NBA、CBA及国际篮球赛事全覆盖，实时数据追踪",
    icon: "ri-basketball-line",
    matchCount: 36,
    articleCount: 128,
  },
  {
    id: "cat-3",
    name: "综合格斗",
    slug: "mma",
    description: "UFC、ONE冠军赛等综合格斗赛事直播与深度报道",
    icon: "ri-boxing-line",
    matchCount: 22,
    articleCount: 89,
  },
  {
    id: "cat-4",
    name: "网球",
    slug: "tennis",
    description: "大满贯、ATP、WTA赛事全覆盖，精彩不容错过",
    icon: "ri-base-station-line",
    matchCount: 30,
    articleCount: 72,
  },
  {
    id: "cat-5",
    name: "电子竞技",
    slug: "esports",
    description: "LOL、DOTA2、CS2等顶级电竞赛事直播与赛程",
    icon: "ri-gamepad-line",
    matchCount: 25,
    articleCount: 95,
  },
  {
    id: "cat-6",
    name: "赛车",
    slug: "racing",
    description: "F1、MotoGP、WRC等全球顶级赛车赛事报道",
    icon: "ri-steering-2-line",
    matchCount: 18,
    articleCount: 54,
  },
];